module.exports = __webpack_public_path__ + "assets/img/key-success-story.0b5f90c0.jpg";